import { ClaimChannel } from "../../model/claim-enquiry/ClaimEnquiry";
import { capitalize } from "./string";

export function readableChannel(channel?: ClaimChannel) {
  if (channel) {
    const capitalizedChannel = capitalize(channel.split(/^ch_/)[1]);
    return `AirHelp${capitalizedChannel}`;
  }
}
